module.exports = __webpack_public_path__ + "static/media/Get_Involved.ab044fd9.svg";